export default __webpack_public_path__ + "static/1128-eddb2adabf7b505a8fd4d23ea28f9bd7.gif";